import { DescriptionWrapper, DescriptionText } from './styles';

const Description = ({ description }) => {
  return (
    <DescriptionWrapper>
      <DescriptionText>{description}</DescriptionText>
    </DescriptionWrapper>
  );
};

export default Description;
